import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)
/**
 * 重写路由的push方法
 */
const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error=> error)
}

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: '首页',
      keepAlive: true
    }
  },
  {
    path: '/cat_menu_list/:category_id',
    name: 'cat_menu_list',
    component: () => import(/* webpackChunkName: "about" */ '../views/cat_menu_list.vue'),
    meta: {
      title: '菜谱列表',
      keepAlive: true

    }
  },
  {
    path: '/menu/:menu_id',
    name: 'menu',
    component: () => import('../views/menu.vue'),
    meta: {
      title: '菜谱详情',
    }
  },
  {
    path: '/loading',
    name: 'loading',
    component: () => import('../views/loading.vue'),
    meta: {
      title: '丘比美味厨房',
    }
  },
  {
    path: '/search',
    name: 'search',
    component: () => import('../views/search.vue'),
    meta: {
      title: '搜索',
      keepAlive: true
    }
  },
  {
    path: '/product_menu',
    name: 'product_menu',
    component: () => import('../views/product_menu.vue'),
    meta: {
      title: '产品菜谱',
      keepAlive: true
    }
  },
  {
    path: '/daily_menu',
    name: 'daily_menu',
    component: () => import('../views/daily_menu.vue'),
    meta: {
      title: '一日三餐',
      keepAlive: true
    }
  },
  {
    path: '/product',
    name: 'product',
    component: () => import('../views/product.vue'),
    meta: {
      title: '公司介绍',
    }
  },
  {
    path: '/video',
    name: 'video',
    component: () => import('../views/video.vue'),
    meta: {
      title: '美食视频',
    }
  },
  {
    path: '/top',
    name: 'top',
    component: () => import(/* webpackChunkName: "about" */ '../views/top.vue'),
    meta: {
      title: '推荐TOP榜',
      keepAlive: true

    }
  },
  {
    path: '/product_tb_buy',
    name: 'product_tb_buy',
    component: () => import(/* webpackChunkName: "about" */ '../views/product_tb_buy.vue'),
    meta: {
      title: '丘比食品旗舰店',
      keepAlive: false

    }
  },

]

// add route path
routes.forEach(route => {
  route.path = route.path || '/' + (route.name || '');
});

const router = new VueRouter({
  routes
});

router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }

  next();
});

export default router
